import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      id: 'airport-transfer',
      icon: 'ri-plane-line',
      title: 'توصيل من المطار',
      description: 'خدمة استقبال من مطار جدة الدولي مع متابعة رحلتك وتوصيلك مباشرة إلى وجهتك في مكة المكرمة أو المدينة المنورة براحة تامة',
      bgImage: 'https://public.readdy.ai/ai/img_res/809065ad0d586a775fc2c1019c9a8ed9.jpg',
      textColor: 'text-white',
      featured: false,
    },
    {
      id: 'hotel-transfer',
      icon: 'ri-building-line',
      title: 'توصيل للفنادق',
      description: 'نقل مريح وآمن من وإلى فنادقك في مكة والمدينة مع خدمة حمل الأمتعة ومساعدة في إجراءات تسجيل الوصول والمغادرة',
      bgImage: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20luxury%20hotel%20building%20in%20mecca%20with%20golden%20sunset%20lighting%2C%20islamic%20architecture%20elements%2C%20elegant%20facade%2C%20professional%20architectural%20photography%2C%20warm%20ambient%20lighting%2C%20prestigious%20hospitality%2C%20spiritual%20atmosphere&width=600&height=800&seq=hotel-mecca-001&orientation=portrait',
      textColor: 'text-white',
      featured: true,
      badge: 'الأكثر طلباً',
    },
    {
      id: 'religious-tours',
      icon: 'ri-map-pin-line',
      title: 'جولات المزارات',
      description: 'رحلات منظمة للمزارات الدينية والأماكن المقدسة مع سائقين على دراية كاملة بالمواقع وأوقات الزيارة المناسبة',
      bgImage: 'https://readdy.ai/api/search-image?query=beautiful%20islamic%20holy%20sites%20and%20religious%20landmarks%20with%20elegant%20architecture%2C%20spiritual%20atmosphere%2C%20warm%20golden%20lighting%2C%20professional%20photography%2C%20peaceful%20ambiance%2C%20sacred%20places%2C%20cultural%20heritage&width=600&height=800&seq=holy-sites-001&orientation=portrait',
      textColor: 'text-white',
      featured: false,
    },
    {
      id: 'vip-service',
      icon: 'ri-vip-crown-line',
      title: 'خدمة VIP الفاخرة',
      description: 'خدمة توصيل فاخرة للغاية مع سيارات من الطراز الأول وخدمات إضافية حصرية لتجربة لا تُنسى',
      bgImage: 'https://readdy.ai/api/search-image?query=ultra%20luxury%20vip%20limousine%20service%20with%20premium%20black%20car%2C%20elegant%20interior%2C%20professional%20chauffeur%2C%20exclusive%20high-end%20transportation%2C%20sophisticated%20atmosphere%2C%20golden%20lighting%2C%20prestigious%20service&width=600&height=800&seq=vip-service-002&orientation=portrait',
      textColor: 'text-white',
      featured: false,
    },
    {
      id: 'group-transfer',
      icon: 'ri-group-line',
      title: 'نقل المجموعات',
      description: 'حلول نقل مثالية للعائلات الكبيرة والمجموعات مع توفير مركبات واسعة ومريحة تتسع للجميع',
      bgImage: 'https://readdy.ai/api/search-image?query=spacious%20luxury%20van%20or%20minibus%20for%20group%20transportation%2C%20comfortable%20interior%20seating%2C%20family-friendly%20vehicle%2C%20professional%20group%20travel%20service%2C%20modern%20design%2C%20warm%20welcoming%20atmosphere&width=600&height=800&seq=group-transfer-002&orientation=portrait',
      textColor: 'text-white',
      featured: false,
    },
    {
      id: 'madinah-transfer',
      icon: 'ri-compass-line',
      title: 'توصيل للمدينة المنورة',
      description: 'رحلات مريحة وآمنة من جدة أو مكة المكرمة إلى المدينة المنورة مع توفير أقصى درجات الراحة طوال الرحلة',
      bgImage: 'https://readdy.ai/api/search-image?query=beautiful%20scenic%20highway%20road%20to%20madinah%20with%20luxury%20car%20traveling%2C%20desert%20landscape%2C%20spiritual%20journey%20atmosphere%2C%20golden%20sunset%20lighting%2C%20peaceful%20travel%20experience%2C%20saudi%20arabia%20landscape&width=600&height=800&seq=madinah-transfer-002&orientation=portrait',
      textColor: 'text-white',
      featured: false,
    },
  ];

  const handleServiceClick = (serviceId: string) => {
    window.REACT_APP_NAVIGATE(`/service-details/${serviceId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=fleet%20of%20luxury%20black%20cars%20parked%20in%20elegant%20formation%2C%20professional%20transportation%20service%2C%20modern%20vehicles%2C%20premium%20quality%2C%20clean%20organized%20display%2C%20golden%20sunset%20lighting%2C%20sophisticated%20business%20atmosphere%2C%20saudi%20arabia%20style&width=1920&height=800&seq=services-hero-001&orientation=landscape"
            alt="خدماتنا"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        </div>
        
        <div className="container mx-auto px-6 lg:px-20 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 bg-gold/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-service-line text-gold text-sm"></i>
            <span className="text-gold font-cairo font-bold text-sm">خدمات متميزة</span>
          </div>
          
          <h1 className="text-white font-almarai font-black text-5xl lg:text-7xl mb-6">
            خدماتنا <span className="text-gold">الفاخرة</span>
          </h1>
          
          <div className="w-24 h-1.5 bg-gold mx-auto mb-6"></div>
          
          <p className="text-white/90 font-cairo text-xl max-w-3xl mx-auto leading-relaxed">
            نقدم مجموعة شاملة من خدمات النقل الفاخر لتلبية جميع احتياجاتك في رحلتك الروحانية
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-gradient-to-b from-white to-luxury-cream">
        <div className="container mx-auto px-6 lg:px-20">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h3 className="text-luxury-black font-almarai font-bold text-4xl lg:text-5xl mb-4">
              خدماتنا <span className="text-gold">المميزة</span>
            </h3>
            <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
            <p className="text-luxury-gray font-cairo text-lg max-w-2xl mx-auto">
              نقدم مجموعة شاملة من خدمات التوصيل الفاخرة لتلبية جميع احتياجاتكم
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => handleServiceClick(service.id)}
                className="relative rounded-3xl p-10 transition-all duration-300 hover:scale-105 hover:shadow-2xl group overflow-hidden cursor-pointer"
                style={{
                  backgroundImage: `url(${service.bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                {/* Overlay for image background */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Badge */}
                  {service.featured && service.badge && (
                    <div className="absolute top-0 right-0 bg-gold/90 backdrop-blur-sm text-luxury-black font-cairo font-semibold text-sm px-4 py-2 rounded-full flex items-center gap-2 mb-6">
                      <i className="ri-star-fill text-sm"></i>
                      <span>{service.badge}</span>
                    </div>
                  )}

                  {/* Icon */}
                  <div className="w-16 h-16 flex items-center justify-center bg-gold/20 backdrop-blur-sm rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${service.icon} text-gold text-3xl`}></i>
                  </div>

                  {/* Title */}
                  <h4 className={`font-cairo font-bold text-2xl mb-4 ${service.textColor}`}>
                    {service.title}
                  </h4>

                  {/* Description */}
                  <p className="font-cairo text-base leading-relaxed mb-6 text-white/80">
                    {service.description}
                  </p>

                  {/* Button */}
                  <button className="font-cairo font-semibold px-6 py-3 rounded-full border-2 border-gold text-gold hover:bg-gold hover:text-luxury-black transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">
                    اعرف المزيد
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
